import { mutatorAction } from 'satcheljs';
import { getQuickComposeViewState } from 'owa-calendar-compose-store-manager';

export const setSurfaceAnchor = mutatorAction(
    'setSurfaceAnchor',
    (formId: string, anchor: HTMLDivElement | string) => {
        const viewState = getQuickComposeViewState(formId);
        if (viewState) {
            viewState.surfaceAnchor = anchor;
        }
    }
);
